// extracted by mini-css-extract-plugin
var _1 = "ra-hide-for-small-only";
var _2 = "ra-pagination";
var _3 = "ra-pagination-item-active";
var _4 = "ra-pagination-item";
var _5 = "ra-pagination-item-disabled";
var _6 = "ra-pagination-item-link";
var _7 = "ra-pagination-item-jump";
var _8 = "ra-pagination-next";
var _9 = "ra-pagination-prev";
var _a = "ra-show-for-large";
var _b = "ra-show-for-xlarge";
export { _1 as "hideForSmallCls", _2 as "paginationCls", _3 as "paginationItemActiveCls", _4 as "paginationItemCls", _5 as "paginationItemDisabledCls", _6 as "paginationItemLinkCls", _7 as "paginationJumpCls", _8 as "paginationNextCls", _9 as "paginationPrevCls", _a as "showForLargeCls", _b as "showForXlargeCls" }
